import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../app-context';
import IGridComponent from '../../../components/grid/i-grid.component';
import TitlePanel from '../../../components/title-panel/title-panel.component';
import { ALL, GET_AMZ_PRODUCT_URL, PAGE_SIZE } from '../../common/constants';
import { formatTo0Decimal, formatTo1Decimal, formatTo2Decimal, isEmptyArray } from '../../common/util.services';
import { getCosting, getInvAttribute, saveCosting, savePrice, syncAmzSkuData } from '../amazon.services';
import IDialogComponent from '../../../components/dialog/i-dialog.component';
import EditCellComponent from '../../costing/detail/edit-cell.component';
import { Box, Grid, Stack } from '@mui/material';
import '../amazon.scss'
import HMobiledataIcon from '@mui/icons-material/HMobiledata';
import AmazonCostingHistory from './costing-history.component';
import { Link } from 'react-router-dom';
import SearchPanel from '../../../components/search-panel/search-panel.component';
import IDropdown from '../../../components/text-component/dropdown/i-dropdown.component';
import ITextField from '../../../components/text-component/textfield/i-textfield.component';
import ICheckbox from '../../../components/checkbox/i-checkbox.component';
import PriceHistoryComponent from '../price/price-history.component';
import YesNoDialog from '../../../components/message-dialog/yes-no-dialog.component';

const AmazonCosting = () => {
  const appContext = useContext(AppContext);
  const rows: GridRowsProp = [];
  const [costingData, setCostingData] = useState(rows);
  const [cellLabel, setCellLabel] = useState('');
  const [cellValueRow, setCellValueRow] = useState<any>([]);
  const [openValue, setOpenValue] = useState(false);
  const [openHistory, setOpenHistory] = useState(false);
  const [openPrice, setOpenPrice] = useState(false);
  const [prdCost, setPrdCost] = useState();
  const [prdPrice, setPrdPrice] = useState();
  const [cellField, setCellField] = useState();
  const [sku, setSku] = useState('');
  const [product, setProduct] = useState(ALL);
  const [color, setColor] = useState(ALL);
  const [size, setSize] = useState(ALL);
  const [pack, setPack] = useState(ALL);
  const [noPrice, setNoPrice] = useState(true);
  const [inactive, setInactive] = useState(false);
  const [colorList, setColorList] = useState();
  const [sizeList, setSizeList] = useState();
  const [packList, setPackList] = useState();
  const [searchText, setSearchText] = useState('');
  const [tacos, setTacos] = useState();
  const [syncType, setSyncType] = useState('');
  const [showSyncMsg, setShowSyncMsg] = useState(false);
  const columns: GridColDef[] = [
    { field: 'product', headerName: 'Product', filterable: false, sortable: false, editable: false, width: 160,
      cellClassName: (params) => { return "CostingPrd" }
    },
    { field: 'image', headerName: 'Pic', filterable: false, sortable: false, editable: false, width: 50,
      renderCell: (params) => (<Box component="img" src={params.row.image} sx={{ height: 25, width: 25, objectFit: 'cover' }}/>)
    },
    { field: 'sku', headerName: 'SKU', filterable: false, sortable: false, editable: false, width: 80,
      renderCell: (params) => { return (<Link to={'https://www.amazon.com/dp/' + params.row.asin} target="_blank">{params.row.sku}</Link>)}
    },
    { field: 'color', headerName: 'Color', filterable: false, sortable: false, editable: false, width: 100},
    { field: 'size', headerName: 'Size', filterable: false, sortable: false, editable: false, width: 95},
    { field: 'unitCount', headerName: 'Pack', filterable: false, sortable: false, editable: false, width: 60},
    { field: 'prdCost', headerName: 'Product', filterable: false, sortable: false, editable: false, width: 70,
      valueFormatter: (value: any) => formatTo2Decimal(value * 1),
      cellClassName: (params) => { return "Costing" }
    },
    { field: 'cost1', headerName: 'Cost 1', filterable: false, sortable: false, editable: false, width: 60,
      valueFormatter: (value: any) => formatTo2Decimal(value * 1), cellClassName: (params) => { return "Cost" }},
    { field: 'cost2', headerName: 'Cost 2', filterable: false, sortable: false, editable: false, width: 60,
      valueFormatter: (value: any) => formatTo2Decimal(value * 1), cellClassName: (params) => { return "Cost" }},
    { field: 'cost3', headerName: 'Cost 3', filterable: false, sortable: false, editable: false, width: 60,
      valueFormatter: (value: any) => formatTo2Decimal(value * 1), cellClassName: (params) => { return "Cost" }},
    /*{ field: 'cost4', headerName: 'Cost 4', filterable: false, sortable: false, editable: false, width: 60,
      valueFormatter: (value: any) => formatTo2Decimal(value * 1), cellClassName: (params) => { return "Cost" }},
    { field: 'cost5', headerName: 'Cost 5', filterable: false, sortable: false, editable: false, width: 60,
      valueFormatter: (value: any) => formatTo2Decimal(value * 1), cellClassName: (params) => { return "Cost" }},*/
    { field: 'costHistory', headerName: 'Hist', filterable: false, sortable: false, editable: false, width: 50,
      renderCell: (params) => (<Stack direction="row" alignItems="center" gap={1}>
                               <HMobiledataIcon fontSize='small' color="primary"/></Stack>),
    },
    { field: 'inlandTransport', headerName: 'Inland', filterable: false, sortable: false, editable: false, width: 65,
      valueFormatter: (value: any) => formatTo2Decimal(value)
    },
    { field: 'originPort', headerName: 'Port (O)', filterable: false, sortable: false, editable: false, width: 70,
      valueFormatter: (value: any) => formatTo2Decimal(value)
    },
    { field: 'oceanFreight', headerName: 'Ocean', filterable: false, sortable: false, editable: false, width: 60,
      valueFormatter: (value: any) => formatTo2Decimal(value)
    },
    { field: 'destinationPort', headerName: 'Port (D)', filterable: false, sortable: false, editable: false, width: 70,
      valueFormatter: (value: any) => formatTo2Decimal(value)
    },
    { field: 'customDuty', headerName: 'Custom', filterable: false, sortable: false, editable: false, width: 70,
      valueFormatter: (value: any) => formatTo2Decimal(value)
    },
    { field: 'destinationClearance', headerName: 'Dest', filterable: false, sortable: false, editable: false, width: 60,
      valueFormatter: (value: any) => formatTo2Decimal(value)
    },
    { field: 'lfhCost', headerName: 'LFH Cost', filterable: false, sortable: false, editable: false, width: 80,
      valueFormatter: (value: any) => formatTo2Decimal(value),
      cellClassName: (params) => { return "Costing" }
    },
    { field: 'fulfillmentFee', headerName: 'Fulfill', filterable: false, sortable: false, editable: false, width: 65,
      valueFormatter: (value: any) => formatTo2Decimal(value)
    },
    { field: 'fulfillmentPct', headerName: 'Fulfill/SP', filterable: false, sortable: false, editable: false, width: 80,
      valueFormatter: (value: any) => formatTo1Decimal(value * 100) + '%'
    },
    { field: 'referralFee', headerName: 'Refer', filterable: false, sortable: false, editable: false, width: 65,
      valueFormatter: (value: any) => formatTo2Decimal(value)
    },
    { field: 'otherCost', headerName: 'Conti', filterable: false, sortable: false, editable: false, width: 60,
      valueFormatter: (value: any) => formatTo2Decimal(value)
    },
    { field: 'amzCost', headerName: 'Amz Cost', filterable: false, sortable: false, editable: false, width: 80,
      valueFormatter: (value: any) => formatTo2Decimal(value)
    },
    { field: 'amzCostPct', headerName: 'Amz/SP', filterable: false, sortable: false, editable: false, width: 70,
      valueFormatter: (value: any) => formatTo0Decimal(value * 100) + '%',
      cellClassName: (params) => { return "Costing" }
    },
    { field: 'tacos', headerName: 'TACOS', filterable: false, sortable: false, editable: false, width: 70,
      valueFormatter: (value: any) => formatTo0Decimal(value * 100) + '%',
      cellClassName: (params) => { return "Costing" }
    },
    { field: 'adCost', headerName: 'Ad Cost', filterable: false, sortable: false, editable: false, width: 75,
      valueFormatter: (value: any) => formatTo2Decimal(value)
    },
    { field: 'xneetiFee', headerName: 'Xneeti', filterable: false, sortable: false, editable: false, width: 70,
      valueFormatter: (value: any) => formatTo2Decimal(value)
    },
    { field: 'totalCost', headerName: 'Total', filterable: false, sortable: false, editable: false, width: 70,
      valueFormatter: (value: any) => formatTo2Decimal(value),
      cellClassName: (params) => { return "Costing" }
    },
    { field: 'price', headerName: 'Price', filterable: false, sortable: false, editable: false, width: 70,
      valueFormatter: (value: any) => formatTo2Decimal(value * 1),
      cellClassName: (params) => { return "Costing" }
    },
    { field: 'priceHistory', headerName: 'Hist', filterable: false, sortable: false, editable: false, width: 50,
      renderCell: (params) => (<Stack direction="row" alignItems="center" gap={1}>
                               <HMobiledataIcon fontSize='small' color="primary"/></Stack>),
    },
    { field: 'prdPct', headerName: 'Prd/SP', filterable: false, sortable: false, editable: false, width: 70,
      valueFormatter: (value: any) => formatTo0Decimal(value * 100) + '%'
    },
    { field: 'lfhCostPct', headerName: 'LFH/SP', filterable: false, sortable: false, editable: false, width: 65,
      valueFormatter: (value: any) => formatTo0Decimal(value * 100) + '%'
    },
    { field: 'otherGain', headerName: 'Oth Gain', filterable: false, sortable: false, editable: false, width: 75,
      valueFormatter: (value: any) => formatTo2Decimal(value)
    },
    { field: 'profit', headerName: 'Profit', filterable: false, sortable: false, editable: false, width: 60,
      valueFormatter: (value: any) => formatTo2Decimal(value),
      cellClassName: (params) => { return params.row.profit > 0 ? "CostingPositive" : "CostingNegative" }
    },
    { field: 'profitCostPct', headerName: 'Profit/LFH', filterable: false, sortable: false, editable: false, width: 90,
      valueFormatter: (value: any) => formatTo1Decimal(value * 100) + '%',
      cellClassName: (params) => { return params.row.profitCostPct > 0 ? "CostingPositive" : "CostingNegative" }
    },
    { field: 'profitSalePct', headerName: 'Profit/SP', filterable: false, sortable: false, editable: false, width: 80,
      valueFormatter: (value: any) => formatTo1Decimal(value * 100) + '%',
      cellClassName: (params) => { return params.row.profitSalePct > 0 ? "CostingPositive" : "CostingNegative" }
    },
    { field: 'indiaInv', headerName: 'India Inv', filterable: false, sortable: false, editable: false, width: 80,
      valueFormatter: (value: any) => formatTo2Decimal(value * 1),
    },
    { field: 'usaInv', headerName: 'USA Inv', filterable: false, sortable: false, editable: false, width: 80,
      valueFormatter: (value: any) => formatTo2Decimal(value * 1),
    }
  ];
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    searchCostingData();
  }, [product, color, size, pack, page, noPrice, inactive, pageSize]);

  function searchCostingData() {
    if (isEmptyArray(rows)) {
      setLoading(true);
      let searchData = {product: product, color: color, size: size, pack: pack, tacos: tacos, 
                        noPrice: noPrice, inactive: inactive, searchText: searchText};
      getCosting(searchData, page, pageSize, appContext,
        (response: any) => {
          setCostingData(response.data.content);
          setTotalRows(response.data.totalElements);
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  }

  const onPaginationModelChange = (evt: any) => {
    setPage(evt.page);
    setPageSize(evt.pageSize);
  }

  const search = () => {
    searchCostingData();
  }

  const handleCellDoubleClick = (value: any) => {
    const field = value.field;
    setCellField(field);
    if('prdCost' === field) {
      setPrdCost(value.row.prdCost);
      setCellValueRow(value.row);
      setCellLabel('Product Cost');
      openValuePopup();
    } else if('price' === field) {
      setPrdPrice(value.row.price);
      setCellValueRow(value.row);
      setCellLabel('Product Price');
      openValuePopup();
    }
  }

  const handleCellClick = (value: any) => {
    const field = value.field;
    if('costHistory' === field) {
      setSku(value.row.sku);
      setOpenHistory(true);
    } else if('priceHistory' === field) {
      setSku(value.row.sku)
      setOpenPrice(true);
    }
  }

  const syncToMaster = () => {
    setSyncType('To');
    setShowSyncMsg(true);
  }

  const syncFromMaster = () => {
    setSyncType('From');
    setShowSyncMsg(true);
  }

  const closePricePage = () => {
    setOpenPrice(false);
  }

  const openValuePopup = () => {
    setOpenValue(true);
  }

  const closeHistory = () => {
    setOpenHistory(false);
  }

  const closeValuePopup = () => {
    if('prdCost' === cellField) {
      saveCostingData()
    } else if ('price' === cellField) {
      savePriceData();
    }
  }

  const onOkClickSync = () => {
    setLoading(true);
    appContext.setShowLoader(true);
    syncAmzSkuData(syncType, appContext,
      (response: any) => {
        appContext.setSuccessMessage(response.message)
        appContext.setShowLoader(false);
        setLoading(false);
      }, (error: any) => {
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message)
        setLoading(false);
    });
  }

  function savePriceData() {
    if(prdPrice !== cellValueRow.price) {
      setLoading(true);
      appContext.setShowLoader(true);
      savePrice(cellValueRow, appContext,
        (response: any) => {
          appContext.setSuccessMessage(response.message)
          appContext.setShowLoader(false);
          setLoading(false);
          setOpenValue(false);
          searchCostingData();
        }, (error: any) => {
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message)
          setLoading(false);
          setOpenValue(false);
      });
    } else {
      setOpenValue(false);
    }
  }

  function saveCostingData() {
    if(prdCost !== cellValueRow.prdCost) {
      setLoading(true);
      appContext.setShowLoader(true);
      saveCosting(cellValueRow, appContext,
        (response: any) => {
          appContext.setSuccessMessage(response.message)
          appContext.setShowLoader(false);
          setLoading(false);
          setOpenValue(false);
          searchCostingData();
        }, (error: any) => {
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message)
          setLoading(false);
          setOpenValue(false);
      });
    } else {
      setOpenValue(false);
    }
  }

  const updateAttributeList = (product: any) => {
    setLoading(true);
    getInvAttribute(product, appContext,
      (response: any) => {
        setColorList(response.data[0]);
        setSizeList(response.data[1]);
        setPackList(response.data[2]);
        appContext.setShowLoader(false);
        appContext.setSuccessMessage(response.message)
        setLoading(false);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
  }

  const getSearchComponent = () => {
    return <SearchPanel search={search}>
      <Grid container spacing={1} alignItems="center">
        <Grid xs={2}>
          <IDropdown name='product' label='Product' url={GET_AMZ_PRODUCT_URL} allItemRequired={true}
            onChangeEvent={(e: any) => {setProduct(e.target.value); setColor(ALL); setSize(ALL); 
                                        setPack(ALL); updateAttributeList(e.target.value);}} />
        </Grid>
        <Grid xs={2}>
          <IDropdown name='color' label='Color' itemList={colorList} allItemRequired={true}
            onChangeEvent={(e: any) => {setColor(e.target.value)}} />
        </Grid>
        <Grid xs={2}>
          <IDropdown name='size' label='Size' itemList={sizeList} allItemRequired={true}
            onChangeEvent={(e: any) => {setSize(e.target.value)}}/>
        </Grid>
        <Grid xs={2}>
          <IDropdown name='pack' label='Pack' itemList={packList} allItemRequired={true}
            onChangeEvent={(e: any) => {setPack(e.target.value)}}/>
        </Grid>
        <Grid xs={1}>
          <ITextField name='searchText' label='Search Text' 
            onActionEvent={(e: any) => {setSearchText(e.target.value)}}/>
        </Grid>
        <Grid xs={1}>
          <ITextField name='tacos' label='TACOS' type='number'
            onActionEvent={(e: any) => {setTacos(e.target.value)}}/>
        </Grid>
        <Grid xs={1}>
          <ICheckbox name='noPrice' label='No Price' defaultChecked={true} 
            onChangeEvent={(e: any) => {setNoPrice(e.target.checked)}}/>
        </Grid>
        <Grid xs={1}>
          <ICheckbox name='inactive' label='Inactive' defaultChecked={false} 
            onChangeEvent={(e: any) => {setInactive(e.target.checked)}}/>
        </Grid>
      </Grid>
    </SearchPanel>
  }

  const getMainPanel = () => {
    return <>
      {getSearchComponent()}
      <IGridComponent title={''} rows={costingData} columns={columns} loading={loading} 
        cellDoubleClick={handleCellDoubleClick} cellClick={handleCellClick}
        showExtBtn={true} extBtnText={'Sync From Master'} extBtnAction={syncFromMaster}
        showExtBtn2={true} extBtn2Text={'Sync To Master'} extBtn2Action={syncToMaster}
        paginationType="server" paginationModelChange={onPaginationModelChange} totalRows={totalRows}
        showAction={false} showAddBtn={false} getRowId={(row: any) => row.sku} maxHeight={450} showEditAction={false}/>
      <IDialogComponent onClose={closeValuePopup} open={openValue} title={'Specify Value'}
        dialogBody={<EditCellComponent data={cellValueRow} close={closeValuePopup} label={cellLabel}/>} />
      <IDialogComponent onClose={closeHistory} open={openHistory} title={'Costing History'}
        dialogBody={<AmazonCostingHistory sku={sku} close={closeHistory}/>} />
      <IDialogComponent onClose={closePricePage} open={openPrice} title={'Price History'}
        dialogBody={<PriceHistoryComponent sku={sku}/>} />
      <YesNoDialog open={showSyncMsg} onClose={() => { setShowSyncMsg(false) }}
        onOk={() => { setShowSyncMsg(false); onOkClickSync(); }} isHorizontal={true} message={'Do you want to sync the data?'}/>
    </>
  }

  return <TitlePanel title='Product Costing' panelBody={getMainPanel()} />
}

export default AmazonCosting;